import { ProjectLabourHourCommitmentType } from "../interfaces/projectLabourHourCommitment/enums";
import { ProjectSocialSpendCommitmentType } from "../interfaces/projectSocialSpendCommitment/enums";
const TRACKING_ONLY_HOURS = {
    [ProjectLabourHourCommitmentType.Fixed]: false,
    [ProjectLabourHourCommitmentType.Headcount]: false,
    [ProjectLabourHourCommitmentType.HeadcountRatio]: false,
    [ProjectLabourHourCommitmentType.Ratio]: false,
    [ProjectLabourHourCommitmentType.TotalHeadcount]: true,
    [ProjectLabourHourCommitmentType.TotalHours]: true
};
const TRACKING_ONLY_SPEND = {
    [ProjectSocialSpendCommitmentType.EmployeeCost]: false,
    [ProjectSocialSpendCommitmentType.EmployeeCostTotal]: true,
    [ProjectSocialSpendCommitmentType.Invoice]: false,
    [ProjectSocialSpendCommitmentType.InvoiceTotal]: true
};
/** Fed by generated employee cost — targeted or tracking. */
const EMPLOYEE_COST_SOURCED = {
    [ProjectSocialSpendCommitmentType.EmployeeCost]: true,
    [ProjectSocialSpendCommitmentType.EmployeeCostTotal]: true,
    [ProjectSocialSpendCommitmentType.Invoice]: false,
    [ProjectSocialSpendCommitmentType.InvoiceTotal]: false
};
/**
 * ABSOLUTE headcount — a whole number of people, targeted or tracking.
 * `HeadcountRatio` is deliberately false: its actuals are employees, but it is a
 * ratio, and every caller wants the absolute/ratio split. A caller asking "is
 * this measured in people?" must list `HeadcountRatio` itself.
 */
const ABSOLUTE_HEADCOUNT = {
    [ProjectLabourHourCommitmentType.Fixed]: false,
    [ProjectLabourHourCommitmentType.Headcount]: true,
    [ProjectLabourHourCommitmentType.HeadcountRatio]: false,
    [ProjectLabourHourCommitmentType.Ratio]: false,
    [ProjectLabourHourCommitmentType.TotalHeadcount]: true,
    [ProjectLabourHourCommitmentType.TotalHours]: false
};
/** Total over the tracking hours types, so a third one is a compile error here
 *  rather than a silent default to "hours". */
const TRACKING_HOUR_UNIT = {
    [ProjectLabourHourCommitmentType.TotalHeadcount]: "headcount",
    [ProjectLabourHourCommitmentType.TotalHours]: "hours"
};
export const isTrackingOnlyHourMetricType = (targetMetricType) => TRACKING_ONLY_HOURS[targetMetricType];
export const isTrackingOnlySpendMetricType = (targetMetricType) => TRACKING_ONLY_SPEND[targetMetricType];
/**
 * **Use this instead of `=== EmployeeCost`.** That comparison decides which
 * Target Definitions get employee-cost rows generated at all, and which are held
 * off the invoice matcher — a tracking definition missing either totals zero or
 * absorbs every invoice on the Project.
 */
export const isEmployeeCostSourced = (targetMetricType) => EMPLOYEE_COST_SOURCED[targetMetricType];
/**
 * The same rule as {@link isEmployeeCostSourced}, as a LIST — for a SQL `IN` or
 * `NOT IN`, which cannot call a predicate per row.
 *
 * Derived from the map rather than written out, so a metric type added to the
 * enum cannot make a query and the predicate disagree. The map is
 * `Record<ProjectSocialSpendCommitmentType, boolean>`, so adding one fails to
 * compile until it is classified.
 */
export const EMPLOYEE_COST_SOURCED_METRIC_TYPES = Object.entries(EMPLOYEE_COST_SOURCED)
    .filter(([, sourced]) => sourced)
    .map(([metricType]) => metricType);
/** **Use this instead of `=== Headcount`** — see the map above. */
export const isAbsoluteHeadcount = (targetMetricType) => ABSOLUTE_HEADCOUNT[targetMetricType];
/** The unit a tracking row's total is in: its column format, and which of the
 *  two tracking tables it belongs to. */
export const trackingHourUnit = (targetMetricType) => TRACKING_HOUR_UNIT[targetMetricType];
/** Ids of the tracking-only definitions among a project's spend commitments.
 *  Read off the project: a package row carries no metric type. */
export const trackingSpendTargetIds = (commitments) => new Set(commitments
    .filter((c) => isTrackingOnlySpendMetricType(c.target_metric_type))
    .map((c) => c.project_social_spend_commitment_id));
